import { Period } from '@frontend/gql/social/graphql';

/**
 * Formats a date based on the specified precision/period
 * @param date - The date to format
 * @param precision - The time period precision (DAY, MONTH, QUARTER)
 * @param options - Additional formatting options
 * @returns Formatted date string
 */
export const formatDateByPrecision = (
  date: Date,
  precision: Period,
  options: { includeYear?: boolean } = {},
): string => {
  const { includeYear = false } = options;

  switch (precision) {
    case 'DAY':
      return date.toLocaleString('default', { month: 'short', day: 'numeric' });
    case 'QUARTER': {
      const quarter = Math.ceil((date.getMonth() + 1) / 3);
      return `Q${quarter} ${date.getFullYear()}`;
    }
    default:
      if (includeYear) {
        return date.toLocaleString('default', { month: 'short', year: 'numeric' });
      }
      return date.toLocaleString('default', { month: 'short' });
  }
};
